module.exports = __webpack_public_path__ + "static/Icons_homeloans_Inactive_large-d481ecf599038245f6f69ec9b86e6c23.png";